'use strict';
function i(t) {
  return t === 0 ? "- kg" : t - Math.floor(t) !== 0 ? `${t.toFixed(1)}kg` : `${t.toFixed(0)}kg`;
}
function d(t) {
  return `${t.toFixed(0)}cm`;
}
function l(t) {
  return t - Math.floor(t) !== 0 ? t.toFixed(1) : t.toFixed(0);
}
function o(t, n) {
  return t - n;
}
function u(t, n) {
  return t - n;
}
function E(t, n) {
  return o(t, n) / t;
}
function I(t, n, e) {
  return o(t, n) / u(t, e);
}
function M(t, n, e, r) {
  return Math.round(r === "F" ? 10 * t + 6.25 * n - 5 * e - 161 : 10 * t + 6.25 * n - 5 * e + 5);
}
const a = {
  sedentary: 1.2,
  mild: 1.375,
  moderate: 1.55,
  heavy: 1.725,
  extreme: 1.9
}, c = {
  mild: 0.9,
  moderate: 1,
  heavy: 1.1
}, f = {
  lose: 500,
  maintain: 0
};
function F(t, n, e, r) {
  return Math.round(
    t * a[n] * c[e] - f[r]
  );
}
export {
  M as calculateBMR,
  F as calculateCalorieTarget,
  l as formatBMI,
  d as formatWaistline,
  i as formatWeight,
  I as getPercentageOfGoal,
  o as getWeightLost,
  E as getWeightLostPercentage,
  u as getWeightToLose
};
